module.exports = __webpack_public_path__ + "static/media/wearefrank.f5091c8b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/wearefrank.webp
// module id = 383
// module chunks = 0